import { normalizeKkmPayloadKey } from './protocol';

const PAN_PATTERN = /\d{12,19}/g;
const DENIED_KEYS = new Set(['clientaddress', 'email', 'phone']);
const SEARCHABLE_IDENTIFIER_KEYS = new Set([
  'authorizationcode',
  'cashierinn',
  'cashiervatin',
  'fiscaldocumentnumber',
  'fiscaldocumentsign',
  'fiscaldrivenumber',
  'fn',
  'fnnumber',
  'fnserial',
  'inn',
  'innorganization',
  'kktnumber',
  // QR-payload ФНС несёт `fn=<16 цифр>`: под маской PAN журнал терял бы номер
  // фискального накопителя ровно в том ответе, где он единственный источник реквизитов.
  'qrcode',
  'receiptnumber',
  'receipturl',
  'registrationnumber',
  'rn',
  'rrn',
  'rrncode',
  'universalid',
  'url',
  'vatin',
]);

export function redactKkmPayload(value: unknown, parentKey?: string): unknown {
  if (Array.isArray(value)) {
    return value.map((item) => redactKkmPayload(item, parentKey));
  }

  if (typeof value === 'object' && value !== null) {
    return Object.fromEntries(
      Object.entries(value)
        .filter(([key]) => !DENIED_KEYS.has(normalizeKkmPayloadKey(key)))
        .map(([key, item]) => [key, redactKkmPayload(item, key)]),
    );
  }

  if (
    typeof value !== 'string' ||
    (parentKey !== undefined && SEARCHABLE_IDENTIFIER_KEYS.has(normalizeKkmPayloadKey(parentKey)))
  ) {
    return value;
  }

  return value.replaceAll(PAN_PATTERN, maskDigitSequence);
}

function maskDigitSequence(digits: string): string {
  return `${digits.slice(0, 4)}${'*'.repeat(digits.length - 8)}${digits.slice(-4)}`;
}
